import styles from "./ConfirmStage.module.css"
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../../../../components/Button/SubmitButton/SubmitButton";
import { useTranslation } from "react-i18next";

/**
* Create account success stage
*/
const ConfirmStage = () => {
    const { t } = useTranslation(); // Translation
    const navigate = useNavigate(); // Navigate

    return(
        <>
        <div className={styles.FormSubtitle}>
            <p className={styles.Title}>{t("create_account.success_title")}</p>
        </div>
        <div className={styles.FormBlock}>
                <SubmitButton text={t("create_account.continue_to_login")} onClick={()=>navigate("/login")} />
        </div>
        </>
    )
};

export default ConfirmStage;
